













export default {
    props: {
        href: String
    },
    data() {
        return {
            iterations: 0,
            totalPrice: 0,
            noOfItems: 0,
            currency: "DKK"
        }
    },
    mounted: function() {
        this.updateCart();    
        const self = this;

        (<HTMLElement>this.$el).addEventListener("updateCart", () => {
            self.updateCart();
        });
    },
    computed: {
        renderTotalPrice() {
            let formatter;
            if(this.currency == 'DKK') {
                formatter = new Intl.NumberFormat('da-DK', {
                    style: 'currency',
                    currency: 'DKK',
                });
            }else {
                formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });
            }

            return formatter.format(this.totalPrice);
            
        }
    },
    methods: {
        updateCart() {
            const self = this;
            let path = `/${window.location.pathname.substr(1).split('/')[0]}/Cart/GetCartInformation`;
            if (window.location.pathname.substr(1).split('/')[0] == "") {
                path = `/Cart/GetCartInformation`;
            }
            fetch(path, {
                method: 'GET',
            }).then(function (response) {
                if (response.ok) {
                    return response.json();
                }
                return Promise.reject(response);
            }).then(function (data) {
                
                self.totalPrice = data.totalPrice;
                self.noOfItems = data.noOfItems;
                self.currency = data.currency;


                if (self.iterations != 0) {
                    (<HTMLElement>self.$refs.ball).classList.add('animate');
                    (<HTMLElement>self.$refs.cart).classList.add('shake');

                    (<HTMLElement>self.$refs.cartcontainer).classList.add('glow');
                    
                    setTimeout(function () {
                        (<HTMLElement>self.$refs.ball).classList.remove('animate');
                    }, 1000);
                    setTimeout(function () {
                        (<HTMLElement>self.$refs.cart).classList.remove('shake');
                    }, 1000);
                    setTimeout(function () {
                        (<HTMLElement>self.$refs.cartcontainer).classList.remove('glow');
                    }, 1200);
                }
                self.iterations++;

            }).catch(function (error) {
                console.warn(error);
            });


        }
    }
}
